export default __webpack_public_path__ + "static/media/489.9af4e1de.jpg";